export const requestTypes = {
    loading: "LOADING_REQUEST",
    delete: "DELETE_REQUEST",
    loadedOne: "LOADED_REQUEST",
    loadedMultiple: "LOADED_REQUESTS",
    success: "SUCCESS_REQUEST",
    restore: "RESTORE_REQUEST",
    hardDelete: "HARDDELETE_REQUEST",
};
